import request from '@/utils/request'


//
export function oauthUrl(oauthUrl) {
  return request({
    url: '/WeixinAuth/oauthUrl',
    method: 'get',
    params: oauthUrl 
  })
}

export function tokenUser(query) {
  return request({
    url: '/WeixinAuth/tokenUser',
    method: 'get',
    params: query
  })
}




export function wxJsSign(query) {
  return request({
    url: '/WeixinAuth/wxJsSign',
    method: 'get',
    params: query 
  })
}




export function uploadMedia(query) {
  return request({
    url: '/WeixinAuth/uploadMedia',
    method: 'post',
    data: query 
  })
}

export function weixinBind(query) {
  return request({
    url: 'Weixin/weixin',
    method: 'post',
    data: query 
  })
}


export function weixinRegister(query) {
  return request({
    url: '/Weixin/user',
    method: 'post',
    data: query
  })
}

export function removeBind(query) {
  return request({
    url: 'Weixin/weixin',
    method: 'delete',
    params: query 
  })
}


//我要报修扫码
export function scanOrderCreate(query) {
  return request({
    url: 'Weixin/qr',
    method: 'get',
    params: query
  })
}




//我要报修扫码
export function getServicer(query) {
  return request({
    url: 'Weixin/company',
    method: 'get',
    params: query
  })
}





// WEBPACK FOOTER //
// ./src/api/weixin.js